import styled from 'styled-components'

export const Box = styled.div`
  padding: 20px 36px 18px 36px;
`

export const AddressWrapper = styled.div`
  display: flex;
`
